export const movementsForMerchantEndPoint = 'Merchant/GetMovementsForMerchant';
